"use client"

import Box from "@mui/material/Box"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { CancelButton } from "@src/components/Button"
import Icons from "@src/components/Icons"
import NextLink from "next/link"
import { useTranslation } from "react-i18next"

const HeadphoneItem = ({ onClose }) => {
  const { t } = useTranslation("home-policy")

  return (
    <Box position="relative">
      <Typography mb={2} fontWeight={700} variant="body1" lineHeight="24px">
        {t("support.title")}
      </Typography>
      <Typography
        sx={{
          display: "list-item",
          marginLeft: "20px"
        }}
        variant="body1"
        lineHeight="24px"
      >
        {t("support.hotline_label")}
        <a
          style={{
            textDecoration: "none",
            paddingLeft: "4px"
          }}
          href={`tel:${t("support.hotline_number").replace(/\./g, "")}`}
        >
          <Typography
            sx={{
              color: "#000",
              marginLeft: "5px",
              fontWeight: 600
            }}
            variant="body1"
            component="span"
          >
            {t("support.hotline_number")}
          </Typography>
        </a>
      </Typography>
      <Typography
        sx={{
          display: "list-item",
          marginLeft: "20px"
        }}
        variant="body1"
        lineHeight="24px"
      >
        {t("support.address_label")} {t("support.address_value")}
      </Typography>
      <Typography
        sx={{
          display: "list-item",
          marginLeft: "20px"
        }}
        variant="body1"
        lineHeight="24px"
      >
        {t("support.inbox_label")}
      </Typography>
      <Box>
        <Stack mt={1} alignItems="center">
          <Icons sx={{ paddingRight: 0.5, height: 18 }} name="facebook-address" />
          <Stack
            sx={{
              flexWrap: "wrap",
              "a ": {
                color: "#389E0D"
              }
            }}
            alignItems="center"
            gap={0.5}
          >
            <NextLink href="https://facebook.com/theciu" target="_blank">
              {t("support.facebook_primary")}
            </NextLink>
            <span>{t("support.or")}</span>
            <NextLink href="https://facebook.com/theciusaigon" target="_blank">
              {t("support.facebook_secondary")}
            </NextLink>
          </Stack>
        </Stack>
        <Stack
          sx={{
            "a ": {
              color: "#389E0D"
            }
          }}
          mt={1}
          alignItems="center"
        >
          <Icons
            sx={{
              paddingRight: 0.5,
              height: 18
            }}
            name="instagram"
          />
          <NextLink href="https://instagram.com/theciusaigon" target="_blank">
            {t("support.instagram")}
          </NextLink>
        </Stack>
      </Box>
      <CancelButton
        type="button"
        height="40px"
        label={t("collapse")}
        endIcon={<Icons name="arrow-up" />}
        minHeight="40px"
        minWidth="160px"
        sx={{
          margin: {
            xs: "24px auto 0",
            md: "48px auto 0"
          }
        }}
        onClick={onClose}
      />
    </Box>
  )
}

export default HeadphoneItem
